import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./classModalTour.css";

export function startClassImportModalTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Tour này giúp bạn nhập lớp học từ Excel/CSV đúng chuẩn và xử lý lỗi theo dòng.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    {
      selector: '[data-tour="class-import-header"]',
      title: "Header nhập dữ liệu",
      description:
        "Đây là modal nhập lớp học. Nút lấp lánh mở tour nhanh, nút X dùng để đóng modal.",
      side: "bottom",
    },
    {
      selector: '[data-tour="class-import-upload"]',
      title: "Vùng chọn file",
      description:
        "Kéo thả hoặc chọn file .xlsx/.xls/.csv. Sau khi chọn file hợp lệ mới có thể bấm Nhập dữ liệu.",
      side: "bottom",
    },
    {
      selector: '[data-tour="class-import-template"]',
      title: "Tải file mẫu",
      description:
        "Nên tải mẫu CSV trước khi chuẩn bị dữ liệu để đúng thứ tự cột và định dạng lịch học.",
      side: "bottom",
    },
    {
      selector: '[data-tour="class-import-columns"]',
      title: "Hướng dẫn cột dữ liệu",
      description:
        "Danh sách này giải thích rõ từng cột bắt buộc/tùy chọn và quy tắc mapping chi nhánh, khóa học, trường học.",
      side: "top",
    },
    {
      selector: '[data-tour="class-import-note"]',
      title: "Lưu ý quan trọng",
      description:
        "Nêu các lỗi thường gặp như trùng lớp, sai định dạng lịch học hoặc thiếu dữ liệu bắt buộc.",
      side: "top",
    },
    {
      selector: '[data-tour="class-import-actions"]',
      title: "Thao tác cuối",
      description:
        "Bấm Nhập dữ liệu để xử lý file. Khi có lỗi, phần Kết quả bên dưới sẽ hiển thị chi tiết theo từng dòng.",
      side: "top",
    },
  ];

  const alignElementInView = (el) => {
    if (!el || typeof el.scrollIntoView !== "function") return;
    // Modal import dùng container overflow-y riêng, cần ép scroll theo phần tử mục tiêu.
    el.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  };

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert("Không tìm thấy vùng để chạy hướng dẫn. Hãy mở modal rồi thử lại.");
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "class-modal-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    onHighlightStarted: (element) => {
      alignElementInView(element);
    },
    steps,
  });

  d.drive();
}
